// Imports needed useState function from react
import { useState } from "react";

//imports styling and formats from the other pages
import RulesPage from '../rulesPage/RulesPage';
import Music from '../Music';
import Game from '../Game';

//imports styling for the icon buttons
import './iconRowStyle.css'

//all of the different pages
enum ComponentStates {
  StartScreen,
  UserCreationScreen,
  UserCreationScreen2,
  ResultsScreen,
  OptionsScreen,
  ControlsScreen,
  InfoButton,
  LazerTag,
  CaptureTheFlag, 
  TargetPractice
}


//function that allows us to define buttons for the rule-page 
function IconRow() {
  const [isRulesOpen, setIsRulesOpen] = useState(false);
  const [componentState, setComponentState] = useState<ComponentStates>(ComponentStates.StartScreen);

  const toggleRules = () => {
    setIsRulesOpen(!isRulesOpen);
  };

  const toggleStart = () => {
    setComponentState(ComponentStates.StartScreen);
    setIsRulesOpen(false);
  };

  return (
    <div className="iconRowStyle">
        <div className='icon-row'>
          <button onClick={toggleRules} className='mini-buttons' id='rules-button'></button>
          <button onClick={toggleStart} className='mini-buttons' id='home-button'></button>
          <Music />
        </div>
        {isRulesOpen && <RulesPage />}
        {!isRulesOpen && <Game componentState={componentState} setComponentState={setComponentState} />}
      </div>
  );
}

export default IconRow;
